import { Link } from 'react-router-dom';

const ServiceAreasSection = () => {
  return (
    <section className="bg-gray-950 py-0 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 min-h-[640px]">

          {/* Left Info Panel */}
          <div className="lg:col-span-2 flex flex-col justify-center px-8 lg:px-12 py-16 lg:py-20 bg-gray-950">

            {/* Label */}
            <div className="inline-flex items-center gap-2 mb-6">
              <div className="w-8 h-px bg-[#C4A962]"></div>
              <span className="text-[#C4A962] font-semibold text-sm tracking-widest uppercase">Our Location</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
              Visit Our<br />Wellesley Showroom
            </h2>
            <p className="text-gray-400 text-lg mb-10 leading-relaxed">
              We serve all of Massachusetts and New England. Visit us in Wellesley or let us come to you.
            </p>

            {/* Address Block */}
            <div className="flex items-start gap-4 mb-6 p-5 bg-white/5 rounded-2xl border border-white/10">
              <div className="w-10 h-10 flex items-center justify-center bg-[#C4A962] rounded-xl flex-shrink-0 mt-0.5">
                <i className="ri-map-pin-2-fill text-white text-lg"></i>
              </div>
              <div>
                <div className="text-white font-semibold mb-1">Custom Clothiers</div>
                <div className="text-gray-400 text-sm leading-relaxed">
                  326A Washington St<br />Wellesley, MA 02481
                </div>
              </div>
            </div>

            {/* Hours Block */}
            <div className="flex items-start gap-4 mb-6 p-5 bg-white/5 rounded-2xl border border-white/10">
              <div className="w-10 h-10 flex items-center justify-center bg-[#C4A962] rounded-xl flex-shrink-0 mt-0.5">
                <i className="ri-time-line text-white text-lg"></i>
              </div>
              <div>
                <div className="text-white font-semibold mb-2">Business Hours</div>
                <div className="text-gray-400 text-sm space-y-1">
                  <div className="flex justify-between gap-8">
                    <span>Monday – Friday</span>
                    <span className="text-white font-medium">8:00 AM – 5:00 PM</span>
                  </div>
                  <div className="flex justify-between gap-8">
                    <span>Saturday</span>
                    <span className="text-white font-medium">8:00 AM – 4:00 PM</span>
                  </div>
                  <div className="flex justify-between gap-8">
                    <span>Sunday</span>
                    <span className="text-gray-500">Closed</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Phone Block */}
            <div className="flex items-start gap-4 mb-10 p-5 bg-white/5 rounded-2xl border border-white/10">
              <div className="w-10 h-10 flex items-center justify-center bg-[#C4A962] rounded-xl flex-shrink-0 mt-0.5">
                <i className="ri-phone-fill text-white text-lg"></i>
              </div>
              <div>
                <div className="text-white font-semibold mb-1">Phone</div>
                <a href="tel:781-237-3166" className="text-[#C4A962] font-semibold text-lg hover:text-[#B39952] transition-colors">
                  781-237-3166
                </a>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://maps.google.com/maps?q=326A+Washington+St+Wellesley+MA"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex-1 bg-[#C4A962] text-white text-center px-6 py-3 rounded-xl font-semibold hover:bg-[#B39952] transition-colors whitespace-nowrap"
              >
                <i className="ri-navigation-line mr-2"></i>Get Directions
              </a>
              <Link
                to="/contact"
                className="flex-1 border border-white/20 text-white text-center px-6 py-3 rounded-xl font-semibold hover:bg-white/10 transition-colors whitespace-nowrap"
              >
                Call for Appointment
              </Link>
            </div>
          </div>

          {/* Right Map Panel */}
          <div className="lg:col-span-3 relative min-h-[400px] lg:min-h-full">
            {/* Gold border accent on left edge */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-[#C4A962] to-transparent z-10 hidden lg:block"></div>

            <iframe
              title="Custom Clothiers Location — 326A Washington St, Wellesley MA"
              src="https://maps.google.com/maps?q=42.310564,-71.276001&z=15&t=m&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '400px', display: 'block', filter: 'grayscale(20%) contrast(1.05)' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>

            {/* Overlay badge */}
            <div className="absolute top-6 right-6 bg-gray-950/90 backdrop-blur-sm border border-[#C4A962]/40 rounded-xl px-4 py-3 shadow-2xl">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#C4A962] rounded-lg">
                  <i className="ri-map-pin-fill text-white text-sm"></i>
                </div>
                <div>
                  <div className="text-white font-bold text-sm">Wellesley, MA</div>
                  <div className="text-[#C4A962] text-xs font-medium">Serving All of New England</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ServiceAreasSection;